import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logoImg from '../assets/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Close menu when clicking outside
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (!e.target.closest('.navbar')) setMenuOpen(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [menuOpen]);

  return (
    <nav
      className="navbar"
      style={scrolled ? { boxShadow: '0 8px 32px rgba(0,0,0,0.5)' } : {}}
    >
      {/* ── Brand ── */}
      <div className="navbar-brand">
        <img src={logoImg} alt="Apps ViT Logo" style={logoStyle} />
        <span className="navbar-brand-name">
          Apps<span>ViT</span> Limited
        </span>
      </div>

      {/* ── Desktop + Mobile nav links (single list) ── */}
      <ul className={`navbar-links${menuOpen ? ' open' : ''}`}>
        <li>
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/privacy-policy"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            Privacy
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => `navbar-cta${isActive ? ' active' : ''}`}
          >
            Contact Us
          </NavLink>
        </li>
      </ul>

      {/* ── Hamburger — pushed to right via marginLeft auto in CSS ── */}
      <button
        className="navbar-hamburger"
        onClick={(e) => { e.stopPropagation(); setMenuOpen((o) => !o); }}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px' }}
      >
        <span style={menuOpen ? { transform: 'rotate(45deg) translate(5px, 5px)' } : {}} />
        <span style={menuOpen ? { opacity: 0, transform: 'scaleX(0)' }            : {}} />
        <span style={menuOpen ? { transform: 'rotate(-45deg) translate(5px, -5px)' } : {}} />
      </button>
    </nav>
  );
};

const logoStyle = {
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  objectFit: 'contain',
  filter: 'drop-shadow(0 0 8px rgba(45,212,191,0.35))',
  flexShrink: 0,
};

export default Navbar;